// Lightweight pub/sub for game-style celebrations.
// Anywhere can call celebrate({ emoji, title, subtitle }); CelebrationOverlay listens.
const EVT = "wfw-celebrate";

export const celebrate = (payload) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVT, { detail: payload }));
};

export const onCelebrate = (handler) => {
  if (typeof window === "undefined") return () => {};
  const wrapped = (e) => handler(e.detail);
  window.addEventListener(EVT, wrapped);
  return () => window.removeEventListener(EVT, wrapped);
};
